import { Entity } from "app/models/entity";
import { emptyReferent, Referent } from "../referents/_models";
import { IPagination } from "../_apiResponse";
import {Mean} from "../means/_models";
import {Driver} from "../drivers/_models";

export interface ProvidersPaginated extends IPagination<Provider> { }
export interface Provider extends Entity {
    name: string
    referents: Referent[],
    means: Mean[],
    drivers: Driver[]
}

export const emptyProvider : Provider= {
    id: 0,
    name: '',
    referents: [],
    means: [],
    drivers: []
}
